module.exports = __webpack_public_path__ + "static/media/serbia.aceb1ce2.svg";